import { useState } from 'react';
import { Download, ExternalLink } from 'lucide-react';
import { api } from '../../lib/api';
import { Button } from '../ui/button';
import { ErrorNotice } from '../ui/common';

export function EvidenceFileActions({ id, filename }: { id: string; filename: string }) {
  const [error, setError] = useState<unknown>(null);
  const [busy, setBusy] = useState(false);
  const open = async (disposition: 'inline' | 'attachment') => {
    // Open synchronously so browsers keep the user's click associated with the new tab.
    const tab = window.open('about:blank', '_blank');
    if (tab) tab.opener = null;
    setError(null); setBusy(true);
    try {
      const { url } = await api<{ url: string }>(`/evidence/${id}/download-url?disposition=${disposition}`);
      if (tab) tab.location.replace(url);
      else throw new Error('Allow a new tab to view or download this attachment, then try again.');
    } catch (cause) { tab?.close(); setError(cause); } finally { setBusy(false); }
  };
  return <div className="evidence-file-actions"><div className="button-row">
    <Button type="button" size="sm" variant="ghost" aria-label={`View ${filename}`} disabled={busy} onClick={() => void open('inline')}><ExternalLink size={15} />View</Button>
    <Button type="button" size="icon" variant="ghost" aria-label={`Download ${filename}`} disabled={busy} onClick={() => void open('attachment')}><Download size={16} /></Button>
  </div>{Boolean(error) && <ErrorNotice error={error} />}</div>;
}
